/* eslint-disable no-param-reassign */
import imageUrlBuilder from '@sanity/image-url';
import { createClient } from '@sanity/client';

const client = createClient({
  projectId: process.env.GATSBY_SANITY_PROJECT_ID,
  dataset: process.env.GATSBY_SANITY_DATASET,
  useCdn: false,
  withCredentials: true,
  graphqlTag: process.env.GATSBY_SANITY_GRAPHQL_TAG || 'default',
  apiVersion: '2023-01-01',
});

const builder = imageUrlBuilder(client);

function urlFor(url) {
  return builder.image(url);
}

function emToPxInt(em) {
  return parseInt(em, 10) * 16;
}

async function loadImage(url, elem) {
  return new Promise((resolve, reject) => {
    elem.onload = () => resolve(elem);
    elem.onerror = reject;
    elem.src = url;
  });
}

export { urlFor, emToPxInt, loadImage };
